import styled from "styled-components";

const ModalBody = styled.div``;

export { ModalBody };
